/**
 *
 * TeaserBusinessAssistant
 *
 */

import React from "react";
import { IntlPropType } from "root/libs/core-libs/src";
import IlluFreightShipping from "@dhl-official/icons/illu-freight-shipping.svg";
import { Icon } from "root/libs/ui-components/src";
import { DhlLink } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";
import {
  CardWrapper,
  StyledHeadline,
  StyledText,
  ContentWrapper,
} from "./styled";

const COPY_ID_PREFIX = "TeaserBusinessAssistant";

export default function TeaserBusinessAssistant({ intl }) {
  return (
    <CardWrapper>
      <Icon useAs="decorative" icon={IlluFreightShipping} />
      <ContentWrapper>
        <StyledHeadline tag="h4" designLevel={4}>
          {intl.formatMessage({
            id: `${COPY_ID_PREFIX}.headlineText`,
          })}
        </StyledHeadline>
        <StyledText>
          {intl.formatMessage({
            id: `${COPY_ID_PREFIX}.copyText`,
          })}
        </StyledText>
        <DhlLink
          href={intl.formatMessage({
            id: `${COPY_ID_PREFIX}.buttonUrl`,
          })}
          variant={Variants.primary}
          dataTestid="teaserBusinessAssistantButton"
        >
          {intl.formatMessage({
            id: `${COPY_ID_PREFIX}.buttonText`,
          })}
        </DhlLink>
      </ContentWrapper>
    </CardWrapper>
  );
}

TeaserBusinessAssistant.propTypes = {
  /** Internationalization library */
  intl: IntlPropType.isRequired,
};
